// src/components/CustomButton.tsx
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledButton = styled(Button)(({}) => ({
  gap: 8,
  fontSize: "15px",
  lineHeight: "20px",
  fontWeight: 500,
  textAlign: "center",
  minHeight: "52px",
  "&:not(.w-auto)": {
    minWidth: 140,
  },
  "&.MuiButton-sizeMedium": {
    minHeight: 44,
  },
  ".MuiSvgIcon-root": {
    fontSize: "1.25em",
    height: "auto",
  },
}));
